const state = {}

const getters = {}

const actions = {
  vEmit(context, payload) {}
}

const mutations = {}

export default {
  state,
  getters,
  actions,
  mutations
}